<template>
      <div style="width: 100%;background: #F4F4F4;font-size: 16px;padding-bottom: 60px;">
         <div style="text-align: center;height: 40vh;overflow: hidden" class="p_r">
           <div class="vcenter">
             <img src="../../../../assets/img/jiagong_b2(1).jpg"/>
           </div>
         </div>
        <div style="padding: 20px">
          <span style="font-size: 18px;font-weight: bold;">加工范围</span>
          <div style="width: 100%; text-align: center;" >
            <div style="display:inline-block; width: 45%;margin: 10px 10px 10px 0px ;">
              <table class="tab">
                <thead>
                <tr>
                  <th style="text-align: center;" colspan="2">小线</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="index < 4" :key="index" v-for="(item, index) in jiagong1" :style="{background: index === 0 || index === 2 ? '#F4F4F4' : ''}">
                  <td >{{ item.name }}</td>
                  <td>{{item.sku}}</td>
                </tr>
                <tr style=" background: #F4F4F4;">
                  <td colspan="2">
                    <button class="butt" @click="toCenterUrl('myProcessing')">
                      我要加工
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div style="display:inline-block; width: 45%; margin: 10px 0 10px 10px ;">
              <table class="tab">
                <thead>
                <tr>
                  <th style="text-align: center;" colspan="2">小线</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="index >= 4" :key="index" v-for="(item, index) in jiagong1" :style="{background: index === 4 || index === 6 ? '#F4F4F4' : ''}">
                  <td >{{ item.name }}</td>
                  <td>{{item.sku}}</td>
                </tr>
                <tr style=" background: #F4F4F4;">
                  <td colspan="2">
                    <button @click="toCenterUrl('myProcessing')" class="butt">
                      我要加工
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <span style="font-size: 18px;font-weight: bold;">收费标准</span>
          <div style="width: 100%;margin: 10px;" >
            <div :key="index" v-for="(item, index) in jiagong2"  class="split4_2 bf_4">
              <img v-if="index === 0 || index === 2" src="../../../../assets/img/jiagong_juan.png" />
              <img v-if="index === 1 || index === 3" src="../../../../assets/img/jiagong_ban.png" />
              <div style="font-size: 16px;color: red;margin-top: 10px;">{{ item.sku }}</div>
              <div style="font-size: 14px;margin-top: 10px;">{{ item.name }}</div>
            </div>
          </div>
          <span style="font-size: 18px;font-weight: bold;">加工机器展示</span>
          <div class="lun_fa">
            <ul style="position: relative;overflow: hidden;display: flex;position: absolute; ">
              <li :key="index" v-for="(item, index) in jiagong3" style="margin-left: 20PX; ">
                <img :src="item.sku" height="200" width="250" STYLE="border-radius: 30px"/>
                <p>{{ item.name }}</p>
              </li>
            </ul>
          </div>
        </div>
        </div>
</template>

<script>
import pubilshSet from '../../../../assets/js/pubilshSet'

export default {
  name: 'myMachining',
  props: ['from'],
  data () {
    return {
      jiagong1: [],
      jiagong2: [],
      jiagong3: []
    }
  },
  created () {
    console.log(this.from)
    this.getData()
  },
  methods: {
    getData () {
      this.$axiox.get('/baigang/app/home/getConfig/jiagong1').then(p => {
        this.jiagong1 = JSON.parse(p.data.paramValue)
      })
      this.$axiox.get('/baigang/app/home/getConfig/jiagong2').then(p => {
        this.jiagong2 = JSON.parse(p.data.paramValue)
      })
      this.$axiox.get('/baigang/app/home/getConfig/jiagong3').then(p => {
        this.jiagong3 = JSON.parse(p.data.paramValue)
      })
    },
    toCenterUrl (page) {
      window.open(pubilshSet.userCenterHostUrl + page)
    }
  }
}
</script>
<style scoped>
.tab{
  border: 1px solid #dddddd;
  width: 100%;
  background: #fff;
  text-align: center;
}
td{
  padding: 10px;
}
.butt{
  background: red;
  border: none;
  padding: 5px 5% ;
  color: white;
  border-radius: 5px;
}
.bf_4{
  text-align: center;
  padding: 30px 0 30px 0;
  background: white;
  margin-left: 40px;
}
.split4_2{
  display: inline-block;
  vertical-align: middle;
  width:20%;
}
.lun_fa{
  margin:10px 50px 10px 50px;
  background: white;
  padding:20px 0;
  overflow: hidden;
  text-align: center;
  position: relative;
  height: 200px;
}
.lun_fa>ul{
  animation: 15s dong infinite ;
}
.lun_fa>ul:hover{
  animation-play-state: paused;
}

@keyframes dong {
  0%{
    left: 0;
  }
  20%{
    left: -270px;
  }
  40%{
    left: -540px;
  }
  60%{
    left: -810px;
  }
  80% {
    left: -1080px;
  }
  100% {
    left: -1350px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/page/mySteelMall/myMachining.vue